import React, { useState, useEffect } from 'react';
import PurpleButton from '../common/PurpleButton/PurpleButton';
import './Banner.css';
// import whatsappIcon from '../../assets/images/icons/whatsapp.png';
// import chatIcon from '../../assets/images/icons/chat.png';

const bannerData = [
  {
    id: 1,
    title: "数字化转型",
    subtitle: "助力企业创新发展",
    description: "提供全方位的数字化解决方案，帮助企业实现业务升级",
    image: `${process.env.PUBLIC_URL}/images/banner/image.png`
  },
  {
    id: 2,
    title: "智能科技",
    subtitle: "引领行业未来",
    description: "运用前沿技术，打造智能化业务生态系统",
    image: `${process.env.PUBLIC_URL}/images/banner/image2.png`
  },
  {
    id: 3,
    title: "全球服务",
    subtitle: "跨境贸易解决方案",
    description: "专业的跨境贸易服务，助力企业拓展全球市场",
    image: `${process.env.PUBLIC_URL}/images/banner/image3.png`
  }
];

const Banner = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [currentImage, setCurrentImage] = useState(bannerData[0].image);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // 添加监听滚动事件
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 滚动到顶部函数
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // 自动切换函数
  const autoSlide = () => {
    if (!isAnimating) {
      const nextIndex = (activeIndex + 1) % bannerData.length;
      handleDotClick(nextIndex);
    }
  };

  // 设置自动切换定时器
  useEffect(() => {
    const timer = setInterval(autoSlide, 10000); // 每10秒切换一次

    // 清理定时器
    return () => clearInterval(timer);
  }, [activeIndex, isAnimating]);

  // 添加图片预加载
  useEffect(() => {
    const loadImages = async () => {
      const promises = bannerData.map(item => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = item.image;
          img.onload = resolve;
          img.onerror = reject;
        });
      });

      try {
        await Promise.all(promises);
        setIsLoading(false);
      } catch (error) {
        console.error('Error loading images:', error);
        setIsLoading(false);
      }
    };

    loadImages();
  }, []);

  const handleDotClick = (index) => {
    if (index !== activeIndex && !isAnimating) {
      setIsAnimating(true);
      document.querySelector('.banner').classList.add('fade');
      
      setTimeout(() => {
        setCurrentImage(bannerData[index].image);
        setActiveIndex(index);
        document.querySelector('.banner').classList.remove('fade');
        setIsAnimating(false);
      }, 250);
    }
  };

  if (isLoading) {
    return <div className="banner-loading">Loading...</div>;
  }

  return (
    <section 
      id="home" 
      className={`banner ${isAnimating ? 'fade' : ''}`}
      style={{ backgroundImage: `url(${currentImage})` }}
    >
      <div className="banner-content">
        <p className="banner-subtitle">{bannerData[activeIndex].subtitle}</p>
        <h2>{bannerData[activeIndex].title}</h2>
        <p className="banner-description">
          {bannerData[activeIndex].description}
        </p>
        <PurpleButton 
          text="获取报价" 
          onClick={() => window.location.href = '/contact'} 
        />
      </div>
      {/* <div 
        className={`banner-image ${isAnimating ? 'fade' : ''}`}
        style={{ backgroundImage: `url(${bannerData[activeIndex].image})` }}
      ></div> */}
      <div className="banner-dots">
        {bannerData.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeIndex ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop}>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="currentColor"
            className="scroll-top-icon"
          >
            <path d="M12 4l8 8h-6v8h-4v-8H4z" />
          </svg>
        </div>
      )}
    </section>
  );
};

export default Banner; 